<template>
  <div>
    <div class="dialog--custom-mask"></div>
    <v-dialog v-model="open" persistent max-width="740px" :hide-overlay="this.$route.fullPath.includes('details')"
              attach="RealizationModal">
      <v-card>
        <form @submit.prevent="!isProcessing ? onSubmit() : null" novalidate>
          <v-card-title>
            <span class="headline">Dodawanie realizacji</span>
          </v-card-title>
          <v-card-text>
            <v-container class="pt-0" grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="voucherRealizationDatePicker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formData.realizated_at"
                      label="Wybierz datę"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="formData.realizated_at"
                                   @input="voucherRealizationDatePicker = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Wartość"
                    v-validate="'required|decimal:2'"
                    type="number"
                    v-model="formData.price"
                    data-vv-name="Wartość"
                    :error-messages="errors.collect('Wartość')"
                    browser-autocomplete="off">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Nr paragonu/faktury"
                    v-validate="'required'"
                    v-model="formData.invoice_number"
                    data-vv-name="Nr paragonu/faktury"
                    :error-messages="errors.collect('Nr paragonu/faktury')"
                    browser-autocomplete="off">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Uwagi"
                    v-model="formData.comments"
                    auto-grow
                    rows="3"
                    data-vv-name="Uwagi"
                    browser-autocomplete="off" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat @click="goBack(); formData = setFormDataToDefault();">Anuluj</v-btn>
            <v-btn color="blue darken-1" :disabled="isProcessing" flat type="submit">Zapisz</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  /* eslint-disable no-unused-expressions */

  import {mapActions} from 'vuex';

  export default {
    name: 'AddRealization',
    data() {
      return {
        open: true,
        voucherRealizationDatePicker: false,
        isProcessing: false,
        attachTo: null,
        formData: {
          realizated_at: this.moment(new Date())
            .format('YYYY-MM-DD'),
        },
      };
    },
    methods: {
      ...mapActions('VoucherStore', ['addRealization']),
      goBack() {
        this.$route.fullPath.includes('details') ? this.$router.push({
          name: 'VoucherDetails',
          params: {voucherId: this.$route.params.voucherId},
        }) : this.$router.push({name: 'Vouchers'});
      },
      mounted() {
        this.attachTo = 'RealizationModal';
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              this.addRealization({
                formData: this.formData,
                id: this.$route.params.voucherId,
              })
                .then(() => {
                  this.goBack();
                  this.formData = this.setFormDataToDefault();
                  this.isProcessing = false;
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
      setFormDataToDefault() {
        return {
          realizated_at: this.moment(new Date())
            .format('YYYY-MM-DD'),
        };
      },
    },
  };
</script>
